"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAppContext = exports.AppProvider = exports.AppContext = exports.initialState = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
exports.initialState = {
    currencyCode: ''
};
exports.AppContext = (0, react_1.createContext)({});
const AppProvider = ({ children }) => {
    const [currencyCode, setCurrencyCode] = (0, react_1.useState)('');
    const [countryCode, setCountryCode] = (0, react_1.useState)('');
    const [cryptoCurrencyCode, setCryptoCurrencyCode] = (0, react_1.useState)('');
    const [selectedCurrencyCode, setSelectedCurrencyCode] = (0, react_1.useState)('');
    return ((0, jsx_runtime_1.jsx)(exports.AppContext.Provider, Object.assign({ value: {
            currencyCode,
            countryCode,
            cryptoCurrencyCode,
            selectedCurrencyCode,
            setCurrencyCode,
            setCountryCode,
            setCryptoCurrencyCode,
            setSelectedCurrencyCode
        } }, { children: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children }) })));
};
exports.AppProvider = AppProvider;
const useAppContext = () => (0, react_1.useContext)(exports.AppContext);
exports.useAppContext = useAppContext;
